<template>
  <div class="photo-gallery" id="photo-gallery-wrapper" tabindex="0">
    <div
      class="images-wrapper product-single-gallery"
      @click="openGallery(currentImageIndex)"
      @touchstart.passive="handleTouchStart"
      @touchend.passive="handleTouchEnd"
    >
      <Photo v-if="currentImage" :src="currentImage" class="image" :key="currentImage" />
      <span
        v-if="fullscreenEnabled"
        class="search-icon"
        @click.stop="openGallery(currentImageIndex)"
      >
        <i class="fa fa-search-plus" />
      </span>
    </div>
    <cool-light-box :items="items" :index="index" :loop="true" @close="index = null">
    </cool-light-box>
    <div class="images-wrapper">
      <div
        class="image"
        v-for="(image, imageIndex) in items"
        :id="`image-id-${imageIndex}`"
        :key="imageIndex"
        :class="{ active: imageIndex === currentImageIndex }"
        @click="selectImage(imageIndex)"
        :style="{ height: '100px', width: '100px' }"
      >
        <Photo :src="image" />
      </div>
    </div>
  </div>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

import Photo from '@/components/shared/Image.vue';

export default {
  name: 'PhotoGallery',
  props: {
    gallery: Array,
    fullscreenEnabled: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    CoolLightBox,
    Photo,
  },
  data() {
    return {
      index: null,
      currentImageIndex: 0,
      touchStartX: null,
      touchStartY: null,
    };
  },
  computed: {
    items() {
      return this.gallery?.map((item) => item.src);
    },
    currentImage() {
      return this.items?.[this.currentImageIndex] || this.items?.[0] || null;
    },
  },
  watch: {
    items() {
      this.currentImageIndex = 0;
      this.index = null;
      this.resetTouchState();
    },
  },
  methods: {
    openGallery(imageIndex = this.currentImageIndex) {
      if (!this.items?.length) {
        return;
      }

      this.index = imageIndex;
    },
    selectImage(imageIndex) {
      this.currentImageIndex = imageIndex;
    },
    showPreviousImage() {
      if (!this.items?.length) {
        return;
      }

      this.currentImageIndex = this.currentImageIndex === 0
        ? this.items.length - 1
        : this.currentImageIndex - 1;
    },
    showNextImage() {
      if (!this.items?.length) {
        return;
      }

      this.currentImageIndex = this.currentImageIndex === this.items.length - 1
        ? 0
        : this.currentImageIndex + 1;
    },
    handleTouchStart(event) {
      const [touch] = event.changedTouches || [];

      if (!touch) {
        return;
      }

      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    },
    handleTouchEnd(event) {
      const [touch] = event.changedTouches || [];

      if (!touch || this.touchStartX === null || this.touchStartY === null) {
        this.resetTouchState();
        return;
      }

      const deltaX = touch.clientX - this.touchStartX;
      const deltaY = touch.clientY - this.touchStartY;
      const swipeThreshold = 40;

      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > swipeThreshold) {
        if (deltaX < 0) {
          this.showNextImage();
        } else {
          this.showPreviousImage();
        }
      }

      this.resetTouchState();
    },
    resetTouchState() {
      this.touchStartX = null;
      this.touchStartY = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.product-single-gallery {
  position: relative;
  cursor: pointer;
  touch-action: pan-y;

  .search-icon {
    position: absolute;
    width: 5rem;
    right: 50%;
    bottom: 50%;
    display: flex;
    justify-content: center;
    color: #a0a0a0;
    font-size: 5rem;
    opacity: 0;
    transition: opacity 0.5s;

    i {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 20%;
    }
  }

  &:hover {
    .search-icon {
      opacity: 1;
    }
  }
}

.images-wrapper div {
  cursor: pointer;
}
</style>

<style lang="scss">
// @media (min-width: 992px) {
//   .modal-dialog {
//     max-width: 100%;
//     width: 100%;
//   }
// }

.images-wrapper {
  display: flex;
}
</style>
